import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-go-back-button',
  template: `
    <button class="btn btn-round btn-md btn-primary" (click)="goBack()">
      <span class="icofont icofont-simple-left"></span>
    </button>
  `,
})
export class GoBackButtonComponent {
  constructor(private location: Location) {}

  public goBack() {
    this.location.back();
  }
}
